module.exports = __webpack_public_path__ + "static/media/camping.f0ef87fa.svg";